const AI_EDITOR_FIELDS = [
  "name",
  "prompt",
  "promptDocument",
  "model",
  "credentialId",
  "queueId",
  "maxTokens",
  "temperature",
  "maxMessages",
  "voice",
  "voiceCredentialId",
  "voiceRegion",
  "knowledge",
];

export const buildAiEditorPayload = values =>
  AI_EDITOR_FIELDS.reduce((payload, field) => {
    if (Object.prototype.hasOwnProperty.call(values, field)) {
      payload[field] = values[field];
    }
    return payload;
  }, {});
